module.exports = __webpack_public_path__ + "img/people.bb64d35c.png";